// Package 4, part L: the top bar's mute button (all sound off or back on; the levels are in Settings).

import { setSoundSettings, useSoundSettings } from '@/lib/sound/sound';
import { t } from '@/i18n';
import { cx } from '@/lib/format';

const ON = 'M4 9h4l5-4v14l-5-4H4zM16 9a4 4 0 0 1 0 6M18.5 6.5a7.5 7.5 0 0 1 0 11';
const OFF = 'M4 9h4l5-4v14l-5-4H4zM16 9l5 6M21 9l-5 6';

export function SoundToggle({ className }: { className?: string }) {
  const s = useSoundSettings();
  return (
    <button
      type="button"
      onClick={() => setSoundSettings({ muted: !s.muted })}
      aria-label={s.muted ? t('radio.sound.unmute') : t('radio.sound.mute')}
      aria-pressed={s.muted}
      title={s.muted ? t('radio.sound.unmute') : t('radio.sound.mute')}
      data-testid="sound-toggle"
      className={cx('flex size-7 shrink-0 items-center justify-center rounded-[4px] border border-border text-muted hover:border-line hover:text-text', className)}
    >
      <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d={s.muted ? OFF : ON} />
      </svg>
    </button>
  );
}
